import UserLogin from './login';

export default class UserLoginDesktop extends UserLogin {
}
